import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SignoAuditoriaService } from '@services/auditoria/signo-auditoria.service';
import { AUDITORIA_COMPONENTES, AuditoriaComponenteMeta } from '../diccionario/auditoria-diccionario';
import { coincideFuzzy } from '@shared/utils/fuzzy-search.util';

@Component({
    selector: 'app-menu-auditoria',
    templateUrl: './menu-auditoria.component.html',
    styleUrls: ['./menu-auditoria.component.scss'],
})
export class MenuAuditoriaComponent implements OnInit {

    componentes: AuditoriaComponenteMeta[] = AUDITORIA_COMPONENTES;
    componentesFiltrados: AuditoriaComponenteMeta[] = AUDITORIA_COMPONENTES;
    termino: string = '';
    flagLoaded: boolean = false;

    constructor(
        private signoAuditoriaService: SignoAuditoriaService,
        private router: Router,
    ) {}

    async ngOnInit(): Promise<void> {
        if (!(await this.signoAuditoriaService.puedeAccederAuditoria())) {
            this.signoAuditoriaService.setAccesoDenegado(true);
            this.router.navigateByUrl('/configurar-administracion');
            return;
        }
        this.componentesFiltrados = this.componentes;
        this.flagLoaded = true;
    }

    aplicarFiltro(termino: string): void {
        this.termino = termino;
        if (!termino || !termino.trim()) {
            this.componentesFiltrados = this.componentes;
            return;
        }
        this.componentesFiltrados = this.componentes.filter((c) =>
            coincideFuzzy(`${c.titulo} ${c.descripcion} ${c.audiencia}`, termino),
        );
    }

    entrar(componente: AuditoriaComponenteMeta): void {
        this.signoAuditoriaService.setModuloSeleccionado(componente.modulo);
        this.router.navigateByUrl(componente.ruta);
    }
}
